import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import { ContainerATCCard } from "./gwpatcarea.styled"
import BulletIcon from "../../../../../assets/icons/nova/bullet-orange.svg"

const GwpAtcCardMulti = ({ data, activeOption }) => {
  const activeCard = data[activeOption]

  if (!activeCard) {
    return null
  }

  const { heading, bullets, containerClasses = "", image, value } = activeCard

  return (
    <ContainerATCCard
      flexWrap={["wrap", null, "nowrap"]}
      className={`${containerClasses} bg-nova-base-solid-10 p-1 md:p-2 lg:px-6`}
    >
      <TextElementNova
        element="h4"
        text={heading}
        className="Body-20-Dia-Strong text-center mb-1 md:mb-0"
      />
      <Flex
        alignItems="center"
        justifyContent="center"
        className="max-w-[420px] md:max-w-[465px] mx-auto gap-2"
      >
        <Box width={[100, null, 125]} className="img-box rounded-sm">
          <img
            src={image}
            alt={``}
            role="presentation"
            className="rounded-sm"
          />
        </Box>
        <Box flex={1} alignItems="center" pr={[2, null, null, 1]}>
          {bullets && bullets.length > 0 && (
            <ul className="flex flex-row flex-wrap gap-y-1 gap-x-2 align-center mb-2">
              {bullets.map((bullet, index) => (
                <li
                  key={index}
                  className="Body-10-Dia-Normal items-center gap-1 flex"
                >
                  <BulletIcon />
                  {bullet}
                </li>
              ))}
            </ul>
          )}
          {value ? (
            <TextElementNova
              element="p"
              text={`<i>${value}</i>`}
              className="Body-10-Dia-Normal text-nova-transparency-black-70"
            />
          ) : null}
        </Box>
      </Flex>
    </ContainerATCCard>
  )
}

export default GwpAtcCardMulti
